/**
 * Small localStorage-backed preference helpers, so a few UI choices
 * (the board view filters, the "notify customer" checkbox default)
 * survive a page reload or logging back in later, instead of resetting
 * to their defaults every time.
 *
 * Deliberately NOT per-board or per-user -- just one shared value per key
 * for this browser, which matches what was actually asked for ("keep it
 * how I left it next time I log in").
 */
const PREFIX = 'mavisHelpdesk.';

export const getPref = (key, fallback) => {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
};

export const setPref = (key, value) => {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch (e) {
    // Storage can be unavailable (private browsing, quota) -- losing the
    // preference is harmless, so just skip it rather than crash the app.
  }
};

export const PREF_KEYS = {
  NOTIFY_CUSTOMER_DEFAULT: 'notifyCustomerDefault',
  BOARD_RELATION: 'boardRelation',
  BOARD_SORT: 'boardSort',
  BOARD_SHOW_COMPLETED: 'boardShowCompleted',
  BOARD_VIEW_MODE: 'boardViewMode',
  CHAT_WINDOW_MODE: 'chatWindowMode',
  CHAT_SOUND_MUTED: 'chatSoundMuted',
};
